export class FiltroManifestoPorTemaDTO {

  dataInicial: string;
  dataFinal: string;
  tipoManifesto: string;
  assunto: string;
  classificacao: string;
  tipoJustica: string;
  opcaoJustica: string;
  unidade: string;
  status: string;
  page: number;

  constructor() {

    this.dataInicial = 'null';
    this.dataFinal = 'null';
    this.tipoManifesto = null;
    this.assunto = null;
    this.classificacao = null;
    this.tipoJustica = null;
    this.opcaoJustica = null;
    this.unidade = null;
    this.status = null;
    this.page = 0;

  }

}
